import React, { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ContentContainer, SectionPage, Row, Col, FormHeader, Button, RadioButtonList, tokens, Icon, IconNotificationSuccess, uiIconChevronLeft, Card, CardTitle ,pxToRem} from '@snsw-gel/react';
import { progressStepperHelper, formHeaderLabel, formHeaderTitles } from '../../../services/progress-stepper-helper';
import styles from './SelectedCard.module.scss';
import SCImage from './SC_1.jpg';
import SSCImage from './SSC_1.jpg';
import { dataLayer } from '../../../services/gtm-dataLayer';

const CurrentStatusPage = () => {
    const existingSessionDetails = sessionStorage.getItem('CardType');
    const [cardType, setCardType] = useState(existingSessionDetails || '');

    useEffect(() => {
        const currentUrl=window.location.href;
        const pageName=window.location.href.split('/').pop();
        dataLayer(currentUrl,pageName);
    }, []);

    const onChangeEvent = v => {
        setCardType(v);
        sessionStorage.setItem('CardType', v);
    };

    return (
        <>
            <FormHeader
                title={formHeaderTitles[2]}
                label={formHeaderLabel}
                stepsList={progressStepperHelper(2)}
            />
            <ContentContainer>
                <Row className={styles['heading-row']}>
                    <Col span={12}>
                        <SectionPage>
                            <RadioButtonList
                                id='frgHours'
                                name='Group Hours'
                                legend='How many hours of paid work are you doing per week?'
                                vertical={true}
                                options={[
                                    { value: 'sc', label: 'Not working or working 20 hours or less' },
                                    { value: 'ssc', label: 'More than 20 hours' },
                                ]}
                                onChange={onChangeEvent}
                                value={String(cardType)}
                            />
                        </SectionPage>
                    </Col>
                </Row>
                {
                    cardType !== '' && (
                        <Row>
                            <Col span={12}>
                                <Card
                                    height='100%'
                                    className={`${styles['card-display']} ${cardType === 'sc' && styles.selected}`}
                                >
                                    <CardTitle
                                        icon={<IconNotificationSuccess />}
                                        text={`You are eligible for a NSW ${cardType === 'sc' ? 'Seniors Card' : 'Senior Savers Card*'}`}
                                        level={4}
                                    />
                                    {
                                        // TODO: Image sizing
                                        cardType === 'sc' && (
                                            <div className={styles['card-content']}>
                                                <div className={styles['card-example-image']}>
                                                    <img src={SCImage} alt='Example Seniors Card' />
                                                </div>
                                                <ul>
                                                    <li>Eligible if you are working 20 hours or less</li>
                                                    <li>Discounts from over 3,400 participating businesses</li>
                                                    <li>Eligible to apply for a Gold Opal card and the NSW National Parks Annual Pass discount</li>
                                                </ul>
                                            </div>
                                        )
                                    }
                                    {
                                        cardType === 'ssc' && (
                                            <>
                                                <div className={styles['card-content']}>
                                                    <div className={styles['card-example-image']}>
                                                        <img src={SSCImage} alt='Example Senior Savers Card' />
                                                    </div>
                                                    <ul>
                                                        <li>Eligible if you are working more than 20 hours</li>
                                                        <li>Discounts from over 3,400 participating businesses</li>
                                                    </ul>
                                                </div>
                                                <p className={styles['card-switching-notice']}>* If your working conditions change, you are able to <a href="https://www.service.nsw.gov.au/transaction/convert-a-nsw-senior-savers-card-to-a-nsw-seniors-card" target="_blank">convert to a NSW Seniors Card online</a>, or by calling 13 77 88.</p>
                                            </>
                                        )
                                    }

                                </Card>
                            </Col>
                        </Row>
                    )
                }
                <Row className={`${styles['button-panel']}`}>
                    <Col span={12}>
                        <Button
                            className={`${styles['button-item']}`}
                            style={{
                                marginTop: `${pxToRem(tokens.spacing.md)}`,
                                marginBottom: `${pxToRem(tokens.spacing.lg)}`,
                                textDecoration: "none"
                            }}
                            id='applyButton'
                            as={Link}
                            href={cardType !== '' ? '/applyMarketingPreferences' : ''}
                            disabled={cardType === ''}
                        >
                            Continue
                        </Button>
                        <br />
                        <Button
                            variant="link"
                            as={Link}
                            href='/profileConnectRedirect'
                            iconStart={<Icon icon={uiIconChevronLeft} />}
                        >
                            Back
                        </Button>
                    </Col>
                </Row>
            </ContentContainer>
        </>
    );
};

export default CurrentStatusPage;

